// extracted by css-extract-rspack-plugin
export default {"Link":"GoogleButton-module__Link___nQFv1"};